import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import SideNavigationBar from "../../components/sideNavigationBar/SideNavigationBar";


import Users from "../../views/setup/users/Users";
import UserDetails from "../../views/setup/users/user/UserDetails";

import { useEffect, useRef, useState } from "react";

import { classNames, withRouter } from "../../shared/utility";
import { getPageTitle } from "../../shared/routeTitles";
import MyAccount from "../../views/myAccount/MyAccount";
import HeaderLayout from "./HeaderLayout";

import Dashboard from "../../views/dashboard/Dashboard";
import UserBusinesses from "../../views/setup/userBusiness/UserBusinesses";
import UserBusinessDetails from "../../views/setup/userBusiness/UserBusinessDetails";


function DefaultLayout(props) {
  const {
    cart,
    orderDetails,
    setCart,
    setOrderDetails,
    logout,
    userType,
    email,
  } = props;
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(true);

  useEffect(() => {
    document.title = getPageTitle(location.pathname);
  }, [location.pathname]);

  const size = useWindowSize();

  useEffect(() => {
    if (size.width < 991) {
      setSidebarOpen(false);
    } else {
      setSidebarOpen(true);
    }
  }, [size]);

  const outsideClickRef = useRef(null);

  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (
        outsideClickRef.current &&
        !outsideClickRef.current.contains(event.target) &&
        size.width < 991
      ) {
        setSidebarOpen(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [outsideClickRef, size]);

  return (
    <div
      className={classNames(
        sidebarOpen
          ? size.width < 991
            ? "scroll-blocked layout-mobile-active"
            : ""
          : "layout-static-inactive",
        "layout-container layout-static layout-light"
      )}
    >
      <SideNavigationBar
        userType={userType}
        outsideClickRef={outsideClickRef}
      />

      <div className="layout-content-wrapper">
        <div className="layout-mask"></div>
        <HeaderLayout
          cart={cart}
          openCart={() => (window.location = "/cart")}
          sidebarOpen={sidebarOpen}
          logout={logout}
          setSidebarOpen={setSidebarOpen}
        />
        <main className="layout-main">
        <Routes>
          <Route path="/my-account" element={<MyAccount />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/users" element={<Users />} />
          <Route path="/users/new" element={<UserDetails />} />
          <Route path="/users/:userId" element={<UserDetails />} />


          <Route path="/user-businesses" element={<UserBusinesses />} />
          <Route path="/user-businesses/new" element={<UserBusinessDetails />} />
          <Route path="/user-businesses/:userBusinessId" element={<UserBusinessDetails />} />


          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
        </main>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    cart: state.cart.cart,
    orderDetails: state.cart.orderDetails,
    userType: state.auth.userType,
    email: state.auth.email,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCart: (newCart) => dispatch(actions.setCart(newCart)),
    setOrderDetails: (customer) => dispatch(actions.setOrderDetails(customer)),
    logout: () => dispatch(actions.logout()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DefaultLayout)
);

function useWindowSize() {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });
  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    // Add event listener
    window.addEventListener("resize", handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount
  return windowSize;
}
